import { createAction, props } from '@ngrx/store';
import { Dossier } from '@models/dossier/dossier';
import { LoadImport } from 'app/modules/dossier-area/ducks/models/loadImport';

// Load actions for different record types
export const loadSuppliersDossier = createAction(
  '[Record] Load supplier dossier',
  props<{ payload: LoadImport }>()
);

export const loadSpeciesDossier = createAction(
  '[Record] Load species dossier',
  props<{ payload: LoadImport }>()
);

export const loadCitationDossier = createAction(
  '[Record] Load citation dossier',
  props<{ payload: LoadImport }>()
);

export const loadRecordDossierSuccess = createAction(
  '[Record] Load record dossier (Success)',
  props<{ dossier: Dossier }>()
);

export const loadRecordDossierError = createAction(
  '[Record] Load new record dossier (Error)'
);

// Citation actions
export const deleteCitation = createAction(
  '[Record] Delete Citation'
);

export const deleteCitationSuccess = createAction(
  '[Record] Delete Citation (Success)'
);

export const deleteCitationError = createAction(
  '[Record] Delete Citation (Error)'
);

export const updateCitation = createAction(
  '[Record] Update Citation'
);

export const updateCitationSuccess = createAction(
  '[Record] Update Citation (Success)'
);

export const updateCitationError = createAction(
  '[Record] Update Citation (Error)'
);

// Species actions
export const deleteSpecies = createAction(
  '[Record] Delete Species'
);

export const deleteSpeciesSuccess = createAction(
  '[Record] Delete Species (Success)'
);

export const deleteSpeciesError = createAction(
  '[Record] Delete Species (Error)'
);

export const updateSpecies = createAction(
  '[Record] Update Species'
);

export const updateSpeciesSuccess = createAction(
  '[Record] Update Species (Success)'
);

export const updateSpeciesError = createAction(
  '[Record] Update Species (Error)'
);

// Other actions
export const clearReferences = createAction(
  '[Record] Clear references.'
);

export const referenceViolationOccured = createAction(
  '[Record] Reference violation occured.'
);

// Effect actions for async operations
export const deleteCitationEffect = createAction(
  '[Citation - Effect] Delete citation',
  props<{ recordId: number }>()
);

export const deleteCitationSuccessEffect = createAction(
  '[Citation - Effect] Delete citation (Success)'
);

export const deleteCitationErrorEffect = createAction(
  '[Citation - Effect] Delete citation (Error)',
  props<{ error: any }>()
);

export const deleteSpeciesEffect = createAction(
  '[Species - Effect] Delete species',
  props<{ recordId: number }>()
);

export const deleteSpeciesSuccessEffect = createAction(
  '[Species - Effect] Delete species (Success)'
);

export const deleteSpeciesErrorEffect = createAction(
  '[Species - Effect] Delete species (Error)',
  props<{ error: any }>()
);
